export const IS_LOGGED = "IS_LOGGED";